/**
 * @file     index.ts
 * @purpose  Public barrel for the analytics subsystem, re-exports types, noop service, and stub service factory.
 */
export * from './analyticsTypes';
export { createAnalyticsService } from './analyticsService';
export { createNoopAnalyticsService } from './noopAnalyticsService';
export { createLiveAnalyticsService } from './liveAnalyticsService';
export { AnalyticsScripts } from './AnalyticsScripts';
export { RouteChangeTracker } from './RouteChangeTracker';
